import React from 'react';
import { Create, ListButton, TopToolbar, useNotify } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import MoralPersonForm from './MoralPersonForm';
import { thereWasProblem, errors } from '../../Utils/messages';

const MoralPersonActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const MoralPersonCreate = (props) => {
  const notify = useNotify();

  const onFailure = (error) => {
    const code = error.body.data.errorCode;
    notify(
      `${thereWasProblem}: ${
        errors[code] || 'Hubo un error con su solicitud, inténtelo mas tarde...'
      }`,
      'warning'
    );
  };

  return (
    <Create
      actions={<MoralPersonActions {...props} />}
      onFailure={onFailure}
      {...props}
    >
      <MoralPersonForm />
    </Create>
  );
};

export default MoralPersonCreate;
